export default __webpack_public_path__ + "static/media/logo.7fdf026c.svg";